import DropCell from './DropCell';
import usePresentSelector from './usePresentSelector';
import { useContext } from 'react';
import G from './Getters';
import getCropDropInfo from './getCropDropInfo';
import { CellDragEnteredContext } from './CellDragEnteredProvider';
import { CropDragContext } from './CropDragProvider';

const sum = row => row.reduce((a,b) => a+b);




export default function CropDropRow({
  figurePanelId,
  rowIndex,
  rowSpacing
}){


  const cropDragContext = useContext(CropDragContext);

  let { cropIdsBeingDragged, setCropIdsBeingDragged, onCropDrop } = cropDragContext || {};

  let { shouldRender, structures, cellSpansMultipleRows, gridIsEmpty } = usePresentSelector(state => {
    return getCropDropInfo(state,{cropIdsBeingDragged,figurePanelId,rowIndex});
  })


  if( !shouldRender ){
    return null;
  }

  if( !figurePanelId ){
    throw Error("CropDropRow requries figurePanelId");
  }

  let numColumns = sum(structures[0]);


  return (
    <>
      {gridIsEmpty && <tr>{Array(numColumns).fill(<td style={{width:30}}></td>)}</tr>}
      { structures.map( (structure,structureIndex) =>{ 

        if(!gridIsEmpty){
          structure = G.amendStructureFromMultiRowSpanCells(null, structure, cellSpansMultipleRows);
        }

        return (
          <tr>
            <td></td>
            {structure.map((length,index) => {

              let colIndex = structure.slice(0,index).reduce((a,b) => a+Math.abs(b),0);

              if( cellSpansMultipleRows[colIndex] ){
                return null;
              }

              return <DropCell 
                {...{
                  setCropIdsBeingDragged,
                  structure,
                  figurePanelId,
                  colIndex,
                  length,
                  cropIdsBeingDragged,
                }}
                rowIndex={rowIndex + ((structureIndex+1)/(structures.length + 1))}
              />
            })}
            <td></td>
          </tr>
        )
      })}
      <tr style={{height:rowSpacing}}></tr>
    </>
  )

}
